"use client";

import Image from "next/image";
import { useState, useEffect } from "react";
import Button from "./Button";

import {
  ClockIcon,
  MapPinIcon,
  CalendarIcon,
} from "@heroicons/react/24/outline";

interface CardEventProps {
  title: string;
  description?: string;
  location: string;
  date: string;
  hour: string;
  image: string;
  slug?: string;
}

export default function CardEvent({
  title,
  location,
  date,
  hour,
  image,
  slug,
}: CardEventProps) {
  const [imageLoading, setImageLoading] = useState(true);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <div className="bg-white overflow-hidden rounded-2xl flex flex-col md:flex-row">
      <div className="w-full md:max-w-52 aspect-video md:aspect-4/5 relative bg-gray-100">
        {mounted && imageLoading && (
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-8 h-8 border-4 border-mygreen/30 border-t-mygreen rounded-full animate-spin"></div>
          </div>
        )}
        <Image
          src={image}
          alt={title}
          className={`w-full h-full object-cover aspect-video transition-opacity duration-300 ${
            mounted && imageLoading ? "opacity-0" : "opacity-100"
          }`}
          width={400}
          height={300}
          unoptimized
          onLoad={() => setImageLoading(false)}
        />
        <span className="absolute top-4 left-4 py-2 px-3 bg-white rounded-full flex gap-1.5 items-center text-xs">
          <CalendarIcon className="w-5 h-5 text-mygreen" />
          {date}
        </span>
      </div>
      <div className="p-6 flex flex-col justify-between gap-4 flex-1">
        <div>
          <h3 className="text-xl line-clamp-2 mb-3">{title}</h3>
          <ul className="grid gap-2">
            <li className="flex items-center gap-1.5">
              <ClockIcon className="w-5 h-5 text-mygreen" /> {hour}
            </li>
            <li className="flex items-center gap-1.5">
              <MapPinIcon className="w-5 h-5 text-mygreen" /> {location}
            </li>
          </ul>
        </div>
        <div>
          <Button href={slug ? `/evento/${slug}` : undefined} disabled={!slug}>
            Saiba mais
          </Button>
        </div>
      </div>
    </div>
  );
}
